import { createSlice } from "@reduxjs/toolkit";
import { LABELGENAPI } from "../../../API";
import { logFrontendActivity } from '../../General/activityLogger';

export const pickupsettingsslice = createSlice({
  name: "pickupsettings",
  initialState: {
    data: [],
    loading: false,
    hasErrors: false,
    notification: { show: false, messageContent: "", messageType: "success" }
  },
  reducers: {
    getPickupSettingsData: (state) => {
      return {
        ...state,
        loading: true,
        hasErrors: false,
      };
    },
    getPickupSettingsDataSuccess: (state, action) => {
      return {
        ...state,
        data:
          action &&
          action.payload &&
          action.payload.data &&
          action.payload.data.data,
        hasErrors: false,
        loading: false,
      };
    },
    getPickupSettingsDataFailure: (state, action) => {
      return {
        ...state,
        loading: false,
        hasErrors: true,
      };
    },

    postPickupSettingsData: (state) => {
      return {
        ...state,
        loading: true,
        hasErrors: false,
      };
    },
    postPickupSettingsDataSuccess: (state, action) => {
      return {
        ...state,
        hasErrors: false,
        loading: false,
        notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
      };
    },
    postPickupSettingsDataFailure: (state, action) => {
      return {
        ...state,
        loading: false,
        hasErrors: true,
        notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
      };
    },
    resetPickupSettings: (state) => {
      return {
        ...state,
        loading: false,
        hasError: false,
        notification: { show: false, messageContent: "", messageType: "success" }
      };
    },
  },
});
export const {
  getPickupSettingsData,
  getPickupSettingsDataSuccess,
  getPickupSettingsDataFailure,
  postPickupSettingsData,
  postPickupSettingsDataSuccess,
  postPickupSettingsDataFailure,
  resetPickupSettings,
} = pickupsettingsslice.actions;

export const getPickupSettings = (data) => (dispatch) => {
  dispatch(getPickupSettingsData());
  try {
    LABELGENAPI.get("/settings/pickup-settings")
      .then(function (response) {
        dispatch(getPickupSettingsDataSuccess(response));
      })
      .catch(function (error) {
        dispatch(getPickupSettingsDataFailure(error.response));
      });
  } catch (error) {
    dispatch(getPickupSettingsDataFailure(error.response));
  }
};
export const postPickupSettings = (userid, data) => (dispatch) => {
  dispatch(postPickupSettingsData());
  const logRef = crypto.randomUUID();
  try {
    LABELGENAPI.post("/settings/pickup-settings", data, { 
        headers: { 
            'x-log-ref': logRef
              } 
        })
      .then(function (response) {
        dispatch(postPickupSettingsDataSuccess(response));
        dispatch(getPickupSettings());
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'PICKUP',
            action: 'SUCCESS',
            request_data: data,
            response_data: response.data,
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }else{
                console.log('Activity log failed:', ref);
            }
        }); 
      })
      .catch(function (error) {
        dispatch(postPickupSettingsDataFailure(error.response));
        logFrontendActivity({
              group: 'SETTINGS',
              subgroup: 'PICKUP',
              action: 'FAILURE',
              request_data: data,
              response_data: error.response?.data || {},
              log_ref: logRef,
              userid: userid
          }).then((ref) => {
              if (ref) {
                  console.log('Activity log recorded with log_ref:', ref);
              }
          }); 
      });
  } catch (error) {
    dispatch(postPickupSettingsDataFailure(error.response));
    logFrontendActivity({
        group: 'SETTINGS',
        subgroup: 'PICKUP',
        action: 'FAILURE',
        request_data: data,
        response_data: error.response?.data || {},
        log_ref: logRef,
        userid: userid
    }).then((ref) => {
        if (ref) {
            console.log('Activity log recorded with log_ref:', ref);
        }
    }); 
  }
};
export const resetPickupSettingsState = (data) => (dispatch) => {
  dispatch(resetPickupSettings());
};

export default pickupsettingsslice.reducer;
